import React from 'react';
import { BaseIoDialog } from './base-io-dialog';
import { IoDialogBasePropTypes, IoDialogType } from './constants';

export const ApproveIoDialog = props => (
  <BaseIoDialog
    name={IoDialogType.Approve}
    title={props.i18n.getString(_TL_('Approve pending orders'))}
    content={props.i18n.getString(_TL_('After you approve these insertion orders, they will become active on the start date.'))}
    confirmButtonText={props.i18n.getString(_TL_('Approve'))}
    {...props}
  />
);

ApproveIoDialog.propTypes = IoDialogBasePropTypes;

export const DeclineIoDialog = props => (
  <BaseIoDialog
    name={IoDialogType.Decline}
    title={props.i18n.getString(_TL_('Decline pending orders'))}
    content={props.i18n.getString(_TL_("Your ads won't serve if you don't have an active insertion order."))}
    confirmButtonText={props.i18n.getString(_TL_('Decline'))}
    {...props}
  />
);

DeclineIoDialog.propTypes = IoDialogBasePropTypes;

export const CancelIoDialog = props => (
  <BaseIoDialog
    name={IoDialogType.Cancel}
    title={props.i18n.getString(_TL_('Are you sure you want to cancel this order?'))}
    content={props.i18n.getString(_TL_('If you cancel this order and have no active orders, your ads will not be eligible to run. After you cancel this order, we will send you an invoice for the amount you spent to date.'))}
    confirmButtonText={props.i18n.getString(_TL_('Cancel Order'))}
    cancelButtonText={props.i18n.getString(_TL_("Don't Cancel"))}
    {...props}
  />
);

CancelIoDialog.propTypes = IoDialogBasePropTypes;
